


















































































































import { Component, Watch, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  AlertCodeALC00002,
  AlertCodeCLT00050,
  AlertCodeIL300079,
  AlertCodeILC00023,
  AlertCodeILC00032,
  AlertCodeTL300003,
  AlertCodeTL300035,
  AlertCodeTL700020,
  AlertCodeTLC00003,
  AuthoritySearchType,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId,
  BibliographyFullIdWithMarcNo,
  Prefix
} from '@/types'
import {
  alertStore,
  modalBibliographyDetailRealStore,
  modalBibliographyDetailSetStore,
  modalBibliographySearchResultStore,
  modalBibliographySearchStore,
  modalErrorStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  BibliographyIntegrationInfoTable,
  BibliographyIntegrationInfoTableItem,
  defaultBibliographyIntegrationInfoTableItem
} from '@/components/organisms/BibliographyIntegrationInfoTable'
import {
  BibliographyIntegrationDataTable,
  BibliographyIntegrationDataTableItem
} from '@/components/organisms/BibliographyIntegrationDataTable'
import {
  Alert,
  AlertMessage,
  bibliographyApi,
  bibliographyRealApi,
  BibliographyRealDetail,
  BibliographySearchResultItem,
  bibliographySetApi,
  BibliographySetDetail,
  collectionApi,
  ErrorMessage,
  SimpleCollection
} from '@/api'
import {
  BibliographyIntegrationSearchConditionItem,
  BibliographyIntegrationSearchConditions,
  defaultBibliographyIntegrationSearchConditionItem
} from '@/components/organisms/BibliographyIntegrationSearchConditions'
import { AlertFactory } from '@/factory'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import CODE_KEY from '@/config/code_key'
import { SelectBibliographyDetailReal } from '@/store/ModalBibliographyDetailRealStore'

export interface ModalBibliographyIntegrationInterface {
  bibliographyFullId: BibliographyFullId
  onProcessed: () => void // 資料の組み換え、書誌統合をしてキャンセルを押下した場合にのみ実行する
}

const DEFAULT_DEST_SEARCH_CONDITION = (): BibliographyIntegrationSearchConditionItem => ({
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  prefix: {
    input: Prefix.Real,
    errorMessage: ''
  },
  bibliographyId: {
    input: '',
    errorMessage: ''
  }
})

const BIBLIOGRAPHY_MAX_DIGITS: number = 10

@Component({
  components: {
    BibliographyIntegrationDataTable,
    BibliographyIntegrationInfoTable,
    BibliographyIntegrationSearchConditions,
    ModalFooter
  }
})
export default class ModalBibliographyIntegration extends ModalComponentBaseVue {
  @Ref()
  destBibliographyIntegrationSearchConditions!: BibliographyIntegrationSearchConditions

  @Ref()
  srcBibliographyIntegrationSearchConditions!: BibliographyIntegrationSearchConditions

  dialog: boolean = false

  tableBodyHeight: number = 0

  processedCallback?: () => void

  destConcreteBibliographyFullId: BibliographyFullId | null = null

  // 統合先のprefix初期選択値はRealとする
  destSearchCondition: BibliographyIntegrationSearchConditionItem = DEFAULT_DEST_SEARCH_CONDITION()

  srcSearchCondition: BibliographyIntegrationSearchConditionItem = defaultBibliographyIntegrationSearchConditionItem()

  destInfoTableItem: BibliographyIntegrationInfoTableItem = defaultBibliographyIntegrationInfoTableItem()

  srcInfoTableItem: BibliographyIntegrationInfoTableItem = defaultBibliographyIntegrationInfoTableItem()

  destDataTableItems: BibliographyIntegrationDataTableItem[] = []

  srcDataTableItems: BibliographyIntegrationDataTableItem[] = []

  // 統合先書誌検索後判定フラグ
  isSearchedDest: boolean = false

  // 統合元書誌検索後判定フラグ
  isSearchedSrc: boolean = false

  // 資料の組み換え、書誌統合をしたか判定
  isProcessed: boolean = false

  isAllSelect: boolean = false

  get isBibliographyReal(): boolean {
    return (
      this.destConcreteBibliographyFullId === null ||
      this.destConcreteBibliographyFullId.prefix === Prefix.Real
    )
  }

  // 統合先固定判定
  get isConcreteDest(): boolean {
    return this.destConcreteBibliographyFullId !== null
  }

  get bibliographyIntegrationSearchConditions(): BibliographyIntegrationSearchConditions {
    if (this.isSearchedDest) {
      return this.srcBibliographyIntegrationSearchConditions
    }

    return this.destBibliographyIntegrationSearchConditions
  }

  get searchCondition(): BibliographyIntegrationSearchConditionItem {
    if (this.isSearchedDest) {
      return this.srcSearchCondition
    }

    return this.destSearchCondition
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.items
  }

  @Watch('searchCondition.bibliographyId.input')
  readingBibliography(newVal: string): void {
    if (newVal.length !== BIBLIOGRAPHY_MAX_DIGITS) return
    this.fetchBibliographyDetail()
  }

  @Watch('dialog')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY // 資料番号入力欄で使用している
      ])

      if (this.destConcreteBibliographyFullId !== null) {
        this.destSearchCondition.prefix.input = this.destConcreteBibliographyFullId.prefix
        this.destSearchCondition.bibliographyId.input = String(
          this.destConcreteBibliographyFullId.id
        ).padStart(10, '0')
      }

      this.$nextTick(() => {
        window.addEventListener('resize', this.calculateTableHeight)
        this.calculateTableHeight()
      })
      return
    }

    this.tableBodyHeight = 0
    this.destConcreteBibliographyFullId = null
    this.destSearchCondition = DEFAULT_DEST_SEARCH_CONDITION()
    this.destInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
    this.destDataTableItems = []
    this.isSearchedDest = false
    this.srcSearchCondition = defaultBibliographyIntegrationSearchConditionItem()
    this.srcInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
    this.srcDataTableItems = []
    this.isSearchedSrc = false
    this.processedCallback = undefined
    this.isProcessed = false
    this.isAllSelect = false

    window.removeEventListener('resize', this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        if (this.processedCallback && this.isProcessed) {
          this.processedCallback()
        }
        this.close()
      }
    })
  }

  onClickLink(bibliographyFullId: BibliographyFullId): void {
    this.openModalBibliographyDetail(
      false,
      bibliographyFullId.prefix,
      bibliographyFullId.id,
      () => {}
    )
  }

  onClickClear(): void {
    if (!this.isConcreteDest) {
      this.destSearchCondition = DEFAULT_DEST_SEARCH_CONDITION()
      this.destInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
      this.destDataTableItems = []
      this.isSearchedDest = false
      this.srcSearchCondition = defaultBibliographyIntegrationSearchConditionItem()
    }
    this.srcSearchCondition.collectionNo.input = ''
    this.srcSearchCondition.collectionNo.errorMessage = ''
    this.srcSearchCondition.bibliographyId.input = ''
    this.srcSearchCondition.bibliographyId.errorMessage = ''
    this.srcInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
    this.srcDataTableItems = []
    this.isSearchedSrc = false
    this.isAllSelect = false
    this.$nextTick(
      this.bibliographyIntegrationSearchConditions.focusCollectionId
    )
  }

  onCLickRecombinant(): void {
    const alert: Alert = AlertFactory.create(
      AlertCodeCLT00050,
      '資料の組み替え'
    )
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.recombinantCollections
    })
  }

  onClickIntegration(): void {
    const alert: Alert = AlertFactory.create(AlertCodeIL300079, '検索履歴')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.integratedBibliography
    })
  }

  onAllSelect(value: boolean): void {
    this.isAllSelect = value
    this.srcDataTableItems.forEach(item => {
      item.isSelected = this.isAllSelect
    })
  }

  // ここでbibliographyFullIdの受取是非で統合先は固定なのかisConcreteDestで判定を取っている
  open(params?: ModalBibliographyIntegrationInterface): void {
    this.destConcreteBibliographyFullId = params?.bibliographyFullId ?? null
    this.processedCallback = params?.onProcessed
    this.dialog = true
  }

  setInfoTableItem(item: BibliographyIntegrationInfoTableItem) {
    if (this.isSearchedDest) {
      this.srcInfoTableItem = item
      return
    }

    this.destInfoTableItem = item
  }

  setDataTableItems(items: BibliographyIntegrationDataTableItem[]): void {
    if (this.isSearchedDest) {
      this.srcDataTableItems = items
      return
    }

    this.destDataTableItems = items
  }

  setSearchedFlag(): void {
    if (this.isSearchedDest) {
      this.isSearchedSrc = true
      return
    }

    this.isSearchedDest = true
  }

  setErrorMessageFetchBibliographyDetail(alerts: Alert[]): void {
    alerts.forEach(alert => {
      if (alert.attribute === 'id') {
        this.searchCondition.bibliographyId.errorMessage = alert.message
      }
    })
  }

  setErrorMessageGetBibliographyFullId(alerts: Alert[]): void {
    alerts.forEach(alert => {
      if (alert.attribute === 'collection_no') {
        this.searchCondition.collectionNo.errorMessage = alert.message
      }
    })
  }

  print() {
    const element = document.querySelector('#modal-bibliography-integration')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  validateSelectBibliographyId(bibliographyFullId: BibliographyFullId): void {
    const alerts: Alert[] = []
    if (
      this.isSearchedDest &&
      this.destSearchCondition.prefix.input !== bibliographyFullId.prefix
    ) {
      alerts.push(AlertFactory.create(AlertCodeTL300003, '書誌階層', '統合'))
    }
    if (bibliographyFullId.prefix === Prefix.Content) {
      alerts.push(AlertFactory.create(AlertCodeTLC00003, '内容書誌', '統合'))
    }
    if (
      !([Prefix.Real, Prefix.Set, Prefix.Content] as string[]).includes(
        bibliographyFullId.prefix
      )
    ) {
      alerts.push(AlertFactory.create(AlertCodeILC00032, '書誌階層'))
    }

    if (alerts.length !== 0) {
      alertStore.setItems(alerts)
      this.searchCondition.prefix.errorMessage = alerts[0].message
      this.$modalAlert.open({
        onOkClick: this.bibliographyIntegrationSearchConditions
          .focusBibliographyId
      })
      return
    }

    this.searchCondition.prefix.input = bibliographyFullId.prefix
    this.searchCondition.bibliographyId.input = String(
      bibliographyFullId.id
    ).padStart(10, '0')
  }

  async fetchBibliographyDetail(): Promise<void> {
    if (
      !this.isSearchedSrc &&
      this.destSearchCondition.prefix.input ===
        this.srcSearchCondition.prefix.input &&
      this.destSearchCondition.bibliographyId.input ===
        this.srcSearchCondition.bibliographyId.input
    ) {
      const alerts: Alert[] = []
      alerts.push(AlertFactory.create(AlertCodeTL300035))
      alertStore.setItems(alerts)
      this.$modalAlert.open({
        onOkClick: () => {
          this.srcSearchCondition.collectionNo.input = ''
          this.srcSearchCondition.collectionNo.errorMessage = ''
          this.srcSearchCondition.bibliographyId.input = ''
          this.srcSearchCondition.bibliographyId.errorMessage = ''
          this.bibliographyIntegrationSearchConditions.focusBibliographyId()
        }
      })
      return
    }

    if (this.searchCondition.prefix.input === Prefix.Real) {
      await this.fetchBibliographyRealDetail()
    } else {
      await this.fetchBibliographySetDetail()
    }
  }

  async fetchBibliographyRealDetail(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const obj: BibliographyRealDetail = await bibliographyRealApi.getBibliography(
        Number(this.searchCondition.bibliographyId.input)
      )
      this.setInfoTableItem({
        searchType: obj.bibliography.searchType,
        bibliographyFullId: {
          prefix: obj.bibliography.prefix,
          id: obj.bibliography.bibliographyId
        },
        displayMaterialFormat: obj.bibliography.displayMaterialFormat,
        displayClass: obj.bibliography.displayClass,
        bibliographySetId: obj.bibliography.bibliographySetId ?? 0,
        displayTitle: obj.bibliography.displayTitle,
        displayAuthor: obj.bibliography.displayAuthor,
        displayPublisher: obj.bibliography.displayPublisher,
        displayPublished: obj.bibliography.displayPublished,
        holdingCount: obj.bibliography.holdingCount,
        orderCount: obj.bibliography.orderCount,
        reserveCount: obj.bibliography.reserveCount,
        collectionFlag: obj.bibliography.collectionFlag
      })
      this.setDataTableItems(
        obj.collections.map(value => {
          return {
            isSelected: false,
            collectionId: value.id,
            collectionNo: value.collectionNo,
            holdingBranchCode: value.holdingBranchCode,
            status: value.status,
            callNo: value.callNo,
            revision: value.revision
          }
        })
      )
      this.setSearchedFlag()
      if (!this.isSearchedSrc) {
        this.srcSearchCondition.prefix.input = this.destSearchCondition.prefix.input
      }

      // 選択処理が終了した段階で資料関連ダイアログを閉じる
      modalBibliographySearchResultStore.close()
      modalBibliographyDetailRealStore.close()
      modalBibliographyDetailSetStore.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageFetchBibliographyDetail(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.bibliographyIntegrationSearchConditions
            .focusBibliographyId
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async fetchBibliographySetDetail(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const obj: BibliographySetDetail = await bibliographySetApi.getBibliography(
        Number(this.searchCondition.bibliographyId.input)
      )
      this.setInfoTableItem({
        searchType: obj.bibliography.searchType,
        bibliographyFullId: {
          prefix: obj.bibliography.prefix,
          id: obj.bibliography.bibliographyId
        },
        displayMaterialFormat: obj.bibliography.displayMaterialFormat,
        displayClass: obj.bibliography.displayClass,
        bibliographySetId: 0,
        displayTitle: obj.bibliography.displayTitle,
        displayAuthor: obj.bibliography.displayAuthor,
        displayPublisher: obj.bibliography.displayPublisher,
        displayPublished: '',
        holdingCount: 0,
        orderCount: 0,
        reserveCount: 0,
        collectionFlag: obj.bibliography.collectionFlag
      })
      this.setDataTableItems([])
      this.setSearchedFlag()
      if (!this.isSearchedSrc) {
        this.srcSearchCondition.prefix.input = this.destSearchCondition.prefix.input
      }

      // 全ての検索処理が終了した段階で検索ダイアログを閉じる
      modalBibliographySearchResultStore.close()
      modalBibliographyDetailRealStore.close()
      modalBibliographyDetailSetStore.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageFetchBibliographyDetail(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.bibliographyIntegrationSearchConditions
            .focusBibliographyId
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.searchCondition.collectionNo.input
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo: this.searchCondition.collectionNo.input,
        simpleCollections: collections,
        onClickOk: (id: number) => this.getBibliographyFullId(id)
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getBibliographyFullId(collectionId: number = 0): Promise<void> {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const bibliographyFullId: BibliographyFullId = await collectionApi.getBibliographyFullId(
        {
          id: collectionId,
          collectionNo:
            collectionId === 0 ? this.searchCondition.collectionNo.input : ''
        }
      )
      if (
        !this.isSearchedSrc &&
        this.destSearchCondition.prefix.input === bibliographyFullId.prefix &&
        Number(this.destSearchCondition.bibliographyId.input) ===
          bibliographyFullId.id
      ) {
        const alerts: Alert[] = []
        alerts.push(AlertFactory.create(AlertCodeTL300035))
        alertStore.setItems(alerts)
        this.$modalAlert.open({
          onOkClick: () => {
            this.srcSearchCondition.collectionNo.input = ''
            this.srcSearchCondition.collectionNo.errorMessage = ''
            this.srcSearchCondition.bibliographyId.input = ''
            this.srcSearchCondition.bibliographyId.errorMessage = ''
            this.bibliographyIntegrationSearchConditions.focusCollectionId()
          }
        })
        return
      }
      this.searchCondition.prefix.input = bibliographyFullId.prefix
      this.searchCondition.bibliographyId.input = String(
        bibliographyFullId.id
      ).padStart(10, '0')
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeTL700020
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessageGetBibliographyFullId(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.bibliographyIntegrationSearchConditions
            .focusCollectionId
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async integratedBibliography(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyApi.integrateBibliography({
        // Number()はゼロサプレスも兼ねて使用しているので変更修正する時はそれらを考慮する事
        id: Number(this.srcSearchCondition.bibliographyId.input),
        prefix: this.srcSearchCondition.prefix.input,
        targetBibliographyRealId: Number(
          this.destSearchCondition.bibliographyId.input
        ),
        targetPrefix: this.destSearchCondition.prefix.input
      })
      this.srcSearchCondition = defaultBibliographyIntegrationSearchConditionItem()
      this.srcInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
      this.srcDataTableItems = []
      this.isSearchedSrc = false
      // ここでウォッチャ発動で書誌検索を行っている
      this.isSearchedDest = false
      this.isProcessed = true
      this.$nextTick(
        this.bibliographyIntegrationSearchConditions.focusCollectionId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async recombinantCollections(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyApi.recombinantCollections({
        // Number()はゼロサプレスも兼ねて使用しているので変更修正する時はそれらを考慮する事
        id: Number(this.srcSearchCondition.bibliographyId.input),
        prefix: this.srcSearchCondition.prefix.input,
        targetBibliographyRealId: Number(
          this.destSearchCondition.bibliographyId.input
        ),
        targetPrefix: this.destSearchCondition.prefix.input,
        collections: this.srcDataTableItems
          .filter(value => value.isSelected)
          .map(value => {
            return {
              id: value.collectionId,
              revision: value.revision
            }
          })
      })
      this.srcSearchCondition = defaultBibliographyIntegrationSearchConditionItem()
      this.srcInfoTableItem = defaultBibliographyIntegrationInfoTableItem()
      this.srcDataTableItems = []
      this.isSearchedSrc = false
      // ここでウォッチャ発動で書誌検索を行っている
      this.isSearchedDest = false
      this.isProcessed = true
      this.$nextTick(
        this.bibliographyIntegrationSearchConditions.focusCollectionId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // ここから資料検索ダイアログ、資料検索結果ダイアログ、資料照会ダイアログの制御記述
  openModalBibliographySearchCondition(isBack: boolean = false) {
    this.$modalBibliographySearchCondition.open({
      isBack,
      onSearch: () => {
        if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
          return
        }
        this.openModalBibliographySearchResult()
      },
      onSearchAuthority: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultContent,
              modalBibliographySearchStore.contentItems[0]
                ?.bibliographyContentId ?? 0
            )
          } else if (modalBibliographySearchStore.authorityItems.length === 1) {
            this.openModalBibliographySearchResultContent()
          } else {
            this.openModalBibliographySearchResultAuthority()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
        } else if (modalBibliographySearchStore.authorityItems.length === 1) {
          this.openModalBibliographySearchResult()
        } else {
          this.openModalBibliographySearchResultAuthority()
        }
      },
      onSearchContent: () => {
        if (modalBibliographySearchStore.contentItems.length === 1) {
          this.openModalBibliographyDetail(
            true,
            modalBibliographySearchStore.contentItems[0].prefix,
            modalBibliographySearchStore.contentItems[0].bibliographyId,
            this.openModalBibliographySearchResultContent,
            modalBibliographySearchStore.contentItems[0]
              ?.bibliographyContentId ?? 0
          )
        } else {
          this.openModalBibliographySearchResultContent()
        }
      }
    })
  }

  openModalBibliographySearchResult(onBackResult?: () => void) {
    this.$modalBibliographySearchResult.open({
      isSelect: true,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onTitle: (bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) => {
        this.openModalBibliographyDetail(
          true,
          bibliographyFullIdWithMarcNo.prefix,
          bibliographyFullIdWithMarcNo?.id ?? 0,
          () => {
            this.openModalBibliographySearchResult(onBackResult)
          }
        )
      },
      onSelect: (
        bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
      ) => {
        if (bibliographyFullIdsWithMarcNo.length > 1) {
          const alert: Alert = AlertFactory.create(AlertCodeILC00023, '書誌')
          alertStore.setItem(alert)
          this.$modalAlert.open()
          return
        }
        this.validateSelectBibliographyId({
          prefix: bibliographyFullIdsWithMarcNo[0].prefix,
          id: bibliographyFullIdsWithMarcNo[0].id ?? 0
        })
      }
    })
  }

  openModalBibliographySearchResultAuthority() {
    this.$modalBibliographySearchResultAuthority.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onSearch: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultAuthority
            )
          } else {
            this.openModalBibliographySearchResultContent()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0]?.bibliographyId ?? 0,
            this.openModalBibliographySearchResultAuthority
          )
        } else {
          this.openModalBibliographySearchResult(
            this.openModalBibliographySearchResultAuthority
          )
        }
      }
    })
  }

  openModalBibliographySearchResultContent() {
    this.$modalBibliographySearchResultContent.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult: this.openModalBibliographySearchResultAuthority,
      onSelectContent: (
        prefix: Prefix,
        bibliographyRealId: number,
        bibliographyContentId: number
      ) => {
        this.openModalBibliographyDetail(
          true,
          prefix,
          bibliographyRealId,
          this.openModalBibliographySearchResultContent,
          bibliographyContentId
        )
      }
    })
  }

  openModalBibliographyDetail(
    isBibliographySelectProcess: boolean,
    prefix: Prefix,
    bibliographyId: number,
    onBackResult: () => void,
    bibliographyContentId?: number
  ) {
    if (prefix === Prefix.Real) {
      this.openModalBibliographyDetailReal(
        isBibliographySelectProcess,
        bibliographyId,
        modalBibliographySearchStore.contentItems.length > 0
          ? BibliographyDetailRealTabType.Content
          : BibliographyDetailRealTabType.Collection,
        onBackResult,
        bibliographyContentId
      )
      return
    }
    this.openModalBibliographyDetailSet(
      isBibliographySelectProcess,
      bibliographyId,
      BibliographyDetailSetTabType.Volume,
      onBackResult
    )
  }

  openModalBibliographyDetailReal(
    isBibliographySelectProcess: boolean,
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    onBackResult: () => void,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      isBibliographySelectProcess,
      bibliographyRealId,
      tabType,
      bibliographyContentId,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (value: SelectBibliographyDetailReal) =>
        this.validateSelectBibliographyId({
          prefix: value.prefix,
          id: value.bibliographyId ?? 0
        }),
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailSetTabType
      ) => {
        this.openModalBibliographyDetailSet(
          true,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }

  openModalBibliographyDetailSet(
    isBibliographySelectProcess: boolean,
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType,
    onBackResult: () => void
  ) {
    this.$modalBibliographyDetailSet.open({
      isBibliographySelectProcess,
      bibliographySetId,
      tabType,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (obj: {
        bibliographyFullId: BibliographyFullId
        selectedBibliographyRealId: number
      }) =>
        this.validateSelectBibliographyId({
          prefix: obj.bibliographyFullId.prefix,
          id: obj.bibliographyFullId.id ?? 0
        }),
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(
          isBibliographySelectProcess,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }
}
